import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import { SvgIconComponent } from "@mui/icons-material";

import {
  ErrorWrapper,
  InfoWrapper,
  SuccessWrapper,
  WarningWrapper,
} from "./styles";
import { NotificationTypes } from "./types";

interface NotificationConfig {
  Wrapper: typeof SuccessWrapper;
  Icon: SvgIconComponent;
  role: "status" | "alert";
  ariaLive: "polite" | "assertive";
  label: string;
}

/**
 * Single source of truth for how each notification type is presented. Keeps the
 * card markup type-agnostic (no per-type JSX duplication).
 */
export const NOTIFICATION_CONFIG: Record<
  NotificationTypes,
  NotificationConfig
> = {
  [NotificationTypes.SUCCESS]: {
    Wrapper: SuccessWrapper,
    Icon: CheckCircleOutlinedIcon,
    role: "status",
    ariaLive: "polite",
    label: "Success notification",
  },
  [NotificationTypes.INFO]: {
    Wrapper: InfoWrapper,
    Icon: InfoOutlinedIcon,
    role: "status",
    ariaLive: "polite",
    label: "Information notification",
  },
  [NotificationTypes.WARNING]: {
    Wrapper: WarningWrapper,
    Icon: ReportProblemOutlinedIcon,
    role: "alert",
    ariaLive: "assertive",
    label: "Warning notification",
  },
  [NotificationTypes.ERROR]: {
    Wrapper: ErrorWrapper,
    Icon: ErrorOutlineOutlinedIcon,
    role: "alert",
    ariaLive: "assertive",
    label: "Error notification",
  },
};
